import React, { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import type { As } from '@mentimeter/ragnar-dsc';

export interface BoxT extends HTMLAttributes<HTMLElement> {
  as?: As;
}

export const Box = forwardRef<HTMLElement, BoxT>((props, ref) => {
  const { className, as = 'div', ...rest } = props;
  const Component = as;

  const defaultClasses = [
    'flex',
    'flex-col',
    'flex-none',
    'items-start',
    'min-w-0',
    'min-h-0',
    'relative',
    'w-auto',
  ];

  return (
    <Component {...rest} ref={ref} className={cn(defaultClasses, className)} />
  );
});
